import { render, staticRenderFns } from "./spot-trade.vue?vue&type=template&id=72b6face&scoped=true"
import script from "./spot-trade.vue?vue&type=script&lang=js"
export * from "./spot-trade.vue?vue&type=script&lang=js"
import style0 from "./spot-trade.vue?vue&type=style&index=0&id=72b6face&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b6face",
  null
  
)

export default component.exports